@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.feedback.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.feedback.resources/"

@delegate:ResourceContentHash(2_521_557)
internal val Res.string.feedback_category_bug: StringResource by lazy {
      StringResource("string:feedback_category_bug", "feedback_category_bug", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 33),
      ))
    }

@delegate:ResourceContentHash(998_879_458)
internal val Res.string.feedback_category_idea: StringResource by lazy {
      StringResource("string:feedback_category_idea", "feedback_category_idea", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44, 38),
      ))
    }

@delegate:ResourceContentHash(-1_560_845_581)
internal val Res.string.feedback_category_other: StringResource by lazy {
      StringResource("string:feedback_category_other", "feedback_category_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83, 39),
      ))
    }

@delegate:ResourceContentHash(-708_916_285)
internal val Res.string.feedback_context_notice: StringResource by lazy {
      StringResource("string:feedback_context_notice", "feedback_context_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 123, 199),
      ))
    }

@delegate:ResourceContentHash(1_535_307_061)
internal val Res.string.feedback_counter: StringResource by lazy {
      StringResource("string:feedback_counter", "feedback_counter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 323, 40),
      ))
    }

@delegate:ResourceContentHash(1_641_470_349)
internal val Res.string.feedback_error_limit: StringResource by lazy {
      StringResource("string:feedback_error_limit", "feedback_error_limit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 364, 128),
      ))
    }

@delegate:ResourceContentHash(-1_345_316_299)
internal val Res.string.feedback_intro: StringResource by lazy {
      StringResource("string:feedback_intro", "feedback_intro", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 493, 166),
      ))
    }

@delegate:ResourceContentHash(544_113_935)
internal val Res.string.feedback_message_label: StringResource by lazy {
      StringResource("string:feedback_message_label", "feedback_message_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 660, 82),
      ))
    }

@delegate:ResourceContentHash(-477_306_862)
internal val Res.string.feedback_message_placeholder: StringResource by lazy {
      StringResource("string:feedback_message_placeholder", "feedback_message_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 743, 96),
      ))
    }

@delegate:ResourceContentHash(366_073_149)
internal val Res.string.feedback_section_category: StringResource by lazy {
      StringResource("string:feedback_section_category", "feedback_section_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 840, 61),
      ))
    }

@delegate:ResourceContentHash(569_622_026)
internal val Res.string.feedback_sent_back: StringResource by lazy {
      StringResource("string:feedback_sent_back", "feedback_sent_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 902, 50),
      ))
    }

@delegate:ResourceContentHash(-142_661_464)
internal val Res.string.feedback_sent_text: StringResource by lazy {
      StringResource("string:feedback_sent_text", "feedback_sent_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 953, 98),
      ))
    }

@delegate:ResourceContentHash(354_044_599)
internal val Res.string.feedback_sent_title: StringResource by lazy {
      StringResource("string:feedback_sent_title", "feedback_sent_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1052, 55),
      ))
    }

@delegate:ResourceContentHash(-1_515_281_033)
internal val Res.string.feedback_submit: StringResource by lazy {
      StringResource("string:feedback_submit", "feedback_submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1108, 35),
      ))
    }

@delegate:ResourceContentHash(-1_698_555_130)
internal val Res.string.feedback_title: StringResource by lazy {
      StringResource("string:feedback_title", "feedback_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1144, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feedback_category_bug", Res.string.feedback_category_bug)
  map.put("feedback_category_idea", Res.string.feedback_category_idea)
  map.put("feedback_category_other", Res.string.feedback_category_other)
  map.put("feedback_context_notice", Res.string.feedback_context_notice)
  map.put("feedback_counter", Res.string.feedback_counter)
  map.put("feedback_error_limit", Res.string.feedback_error_limit)
  map.put("feedback_intro", Res.string.feedback_intro)
  map.put("feedback_message_label", Res.string.feedback_message_label)
  map.put("feedback_message_placeholder", Res.string.feedback_message_placeholder)
  map.put("feedback_section_category", Res.string.feedback_section_category)
  map.put("feedback_sent_back", Res.string.feedback_sent_back)
  map.put("feedback_sent_text", Res.string.feedback_sent_text)
  map.put("feedback_sent_title", Res.string.feedback_sent_title)
  map.put("feedback_submit", Res.string.feedback_submit)
  map.put("feedback_title", Res.string.feedback_title)
}
